module.exports = __webpack_public_path__ + "img/18-doc-detalhados-lista.1d44f162.png";